import { render, staticRenderFns } from "./RemoveApparatus.vue?vue&type=template&id=2b7e45aa"
import script from "./RemoveApparatus.vue?vue&type=script&lang=js"
export * from "./RemoveApparatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports